import { ChangeDetectorRef, Component, computed, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NHAChipComponent } from '@nha/components/chip';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSliderModule } from '@angular/material/slider';
import { FilterBaseSlideComponent } from '../../classes/filter-base-slide-component.class';

@Component({
	selector: 'nha-filter-chip-content',
	standalone: true,
	imports: [CommonModule, NHAChipComponent, MatFormFieldModule, MatInputModule, MatSliderModule],
	templateUrl: './filter-chip-content.component.html',
	styleUrls: ['./filter-chip-content.component.scss']
})
export class NHAFilterChipContentComponent extends FilterBaseSlideComponent implements OnDestroy {
	protected readonly _cdr: ChangeDetectorRef;

	showSearch = computed(() => !this.locked() && this.filter().items.length > 15);

	constructor() {
		const _cdr = inject(ChangeDetectorRef);

		super(_cdr);
	
		this._cdr = _cdr;
	}

	ngOnDestroy(): void {
		super.ngOnDestroy();

		this.searchTerm.set('');
	}
}
